import api from './client'
import type { CreateLeadRequest, Lead, LeadFilters, PaginatedResponse, TransitionStageRequest } from '../api'

export const leadApi = {
  list: async (filters: LeadFilters = {}): Promise<PaginatedResponse<Lead>> => {
    const response = await api.get<PaginatedResponse<Lead>>('/leads', { params: filters })
    return response.data
  },

  get: async (id: string): Promise<Lead> => {
    const response = await api.get<Lead>(`/leads/${id}`)
    return response.data
  },

  create: async (data: CreateLeadRequest): Promise<Lead> => {
    const response = await api.post<Lead>('/leads', data)
    return response.data
  },

  update: async (id: string, data: Partial<CreateLeadRequest>): Promise<Lead> => {
    const response = await api.put<Lead>(`/leads/${id}`, data)
    return response.data
  },

  delete: async (id: string): Promise<void> => {
    await api.delete(`/leads/${id}`)
  },

  transitionStage: async (id: string, data: TransitionStageRequest): Promise<Lead> => {
    const response = await api.post<Lead>(`/leads/${id}/transition`, data)
    return response.data
  },
}
